import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { useEffect, useRef, useState } from "react";

//Components
import { Modal, ModalBody, ModalFooter, Button, Form, Input, Select } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';
import CustomSelect from 'Components/Select';

//Actions
import {
    clearRedux,
    keyfobsGetKeyFobRequest,
    keyfobsGetDriversRequest,
    keyfobsCreateRequest,
    keyfobsUpdateRequest,
    searchEntityRequest,
} from 'Redux/actions';
import { getAccounts } from 'Modules/keysFobs/.components/createEditKeyFob/redux/saga';

//Styles
import './index.scss';

const CreateEditKeyFob = (props) => {
    const { tableRef } = props;
    const { messages } = useIntl();
    const dispatch = useDispatch();
    const formRef = useRef();

    const {
        openModal,
        loading,
        create,
        update,
        keyfob,
        drivers,
        currentId
    } = useSelector(state => state.createEditKeyFobRedux);

    const { keyFobModels } = useSelector(state => state.generalRedux);
    const loadingKeyFobModels = useSelector(state => state.generalRedux.loading);

    const [account, setAccount] = useState(null);
    const [hex, setHex] = useState("");
    const [driver, setDriver] = useState(null);
    const [error, setError] = useState(false);
    const [id, setId] = useState(null);
    const [keyFobModel, setKeyFobModel] = useState(null)

    const closeModal = () => {
        setAccount(null);
        setHex("");
        setDriver(null);
        dispatch(clearRedux("KEYFOBS_CREATE_EDIT"));
        setId(null);
        setKeyFobModel(null)
    }

    const applyChanges = () => {
        let payload = {
            companyId: account?.id,
            hex,
            driverId: driver?.id,
            keyFobModelId: keyFobModel?.id
        }

        if (!id) {
            dispatch(keyfobsCreateRequest(payload))
        } else {
            payload.id = id;
            dispatch(keyfobsUpdateRequest(payload));
        }
    }

    const accountHandler = (newaccount) => {
        if (newaccount) {
            setError(false);
            dispatch(keyfobsGetDriversRequest(newaccount?.name))
        } else {
            setDriver(null);
            dispatch(clearRedux("KEYFOBS_CREATE_EDIT", { drivers: [] }))
        }
        setAccount(newaccount);
    }

    const getAccountsForSelect = (input, callback) => {
        setDriver(null)
        if (!input) {
            callback([])
            return
        }
        getAccounts(input).then((response) => {
            if (response.result) {
                const { items } = response?.result
                callback(items)
            }
        })
    }

    useEffect(() => {
        if (create?.id) {
            NotificationManager.success(
                messages['keyfobs_create_success_message'],
                messages['keyfobs_create_new_driver_key'],
                3000
            );
            closeModal();
            tableRef && tableRef?.current?.getData({ newPage: 0 });
            dispatch(clearRedux("KEYFOBS_CREATE_EDIT", { create: null }))
        }
        if (update?.id) {
            NotificationManager.success(
                messages['keyfobs_update_success_message'],
                messages['keyfobs_create_edit_driver_key'],
                3000
            );
            closeModal();
            tableRef && tableRef?.current?.getData({ newPage: 0 });
            dispatch(clearRedux("KEYFOBS_CREATE_EDIT", { update: null }))
        }
        if (keyfob) {
            setHex(keyfob?.hex || '');
            setId(keyfob?.id);
            setDriver(keyfob?.driverId !== 0 ? keyfob?.driver : null);
            setKeyFobModel(keyfob?.keyFobModel?.id ? keyfob?.keyFobModel : null)
            keyfob?.company?.name && dispatch(keyfobsGetDriversRequest(keyfob?.company?.name));
            setAccount(keyfob?.company);
            dispatch(clearRedux("KEYFOBS_CREATE_EDIT", { keyfob: null }))
        }
        if (currentId) {
            setId(currentId);
            dispatch(keyfobsGetKeyFobRequest(currentId))
            dispatch(clearRedux("KEYFOBS_CREATE_EDIT", { currentId: null }))
        }
    }, [create, update, keyfob, currentId])

    useEffect(() => {
        (!keyFobModels || (keyFobModels && keyFobModels.length === 0)) && dispatch(searchEntityRequest({ key: "keyFobModels" }));
    }, []);
    return (
        <Modal
            open={openModal}
            title={(!id && !currentId) ? messages['keyfobs_create_new_driver_key'] : messages['keyfobs_create_edit_driver_key']}
            handleClose={() => closeModal()}
            position="right"
            loading={loading}
            size="small"
        >
            <ModalBody>
                <div style={{ padding: '0 10px', height: 600 }}>
                    <Form
                        ref={formRef}
                        onValidSubmit={() => {
                            setError(false);
                            applyChanges()
                        }}
                    >
                        <div className="keyfobs-account-container">
                            <CustomSelect
                                async
                                value={account}
                                onChange={(items) => accountHandler(items)}
                                label={messages['keyfobs_account']}
                                placeholder={messages['keyfobs_account']}
                                loadOptions={getAccountsForSelect}
                                required
                                getOptionLabel={e => e.name}
                                getOptionValue={e => e.id}
                                className={error && "keyfobs-account-list"}
                                disabled={id}
                            />
                            {error && <small className="text-danger" style={{ paddingTop: 5 }}>{messages['required_field']}</small>}
                        </div>
                        <div style={{ marginTop: 5 }}>
                            <Input
                                label={messages['keyfobs_identifier']}
                                placeholder={messages['keyfobs_identifier']}
                                value={hex}
                                onChange={(value) => setHex(value)}
                                maxLength={20}
                                required
                                requiredMessage={messages['required_field']}
                            />
                        </div>
                        <div style={{ marginTop: 5 }}>

                            <Select
                                id="key-fob-model"
                                name="KeyFobModel"
                                label={messages["bulk_add_driver_tag_model"]}
                                placeholder={messages["bulk_add_driver_tag_model"]}
                                value={keyFobModel}
                                onChange={(value) => {
                                    setKeyFobModel(value);
                                }}
                                options={keyFobModels}
                                loading={loadingKeyFobModels}
                                textField="name"
                                valueField="id"
                                required
                                requiredMessage={messages['common_field_required']}
                            />

                        </div>
                        <div style={{ marginTop: 5 }}>
                            <Select
                                id="keyfobs-driver.list"
                                label={messages['keyfobs_driver']}
                                placeholder={messages['keyfobs_driver']}
                                options={drivers || []}
                                value={driver}
                                onChange={(value) => setDriver(value)}
                                textField="name"
                                valueField="id"
                                required={!id}
                                requiredMessage={messages['required_field']}
                            />
                        </div>
                    </Form>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['common_cancel']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={() => {
                        if (!account) setError(true);
                        formRef?.current?.submit()
                    }}
                >
                    {messages['save']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default CreateEditKeyFob;